// import React from "react";
// import { useState,useContext } from "react";
// import { Link } from "react-router-dom";

// import { Button, Box, Typography, Paper } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import { BsArrowLeft } from "react-icons/bs";

// import { PersonalDetails } from "./personalDetails";
// import { FamilyDetails } from "./familyDetails";
// import { ContactDetails } from "./contactDetails";
// import "./index.css";
// import translations from "./translation.json";
// import { LanguageContext } from "../../Components/LanguageContext";

// // Styled Step Component (Arrow Shape)
// const StepItem = styled("div")(({ active, completed }) => ({
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   flex: 1,
//   padding: "20px 24px",
//   color: active || completed ? "#FFFFFF" : "#A8A8A8",
//   backgroundColor: completed ? "#F24464" : active ? "#F24464" : "#E4E4E4",
//   border: "1px solid #E4E4E4",
//   position: "relative",
//   clipPath: "polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%)",
//   marginRight: active || completed ? "-8px" : "-8px",
//   zIndex: active ? 2 : completed ? 1 : 0,
//   transition: "0.3s",
//   "&:last-child": {
//     marginRight: 0,
//   },
//   fontSize: "16px",
//   fontWeight: "500",
//   marginTop:"20px"
// }));
// export function AddProfile() {
//     const { language } =useContext(LanguageContext);
//   const [activeStep, setActiveStep] = useState(0);
// // const [getFormData, setGetFormData] = useState(null);

// // const [getFamilyData, setGetFamilyData] = useState(null);

// const steps = [translations[language].personal_details, translations[language].family_details, translations[language].contact_details];

//   const stepContent = [
//   //  <PersonalDetails onDataSave={setGetFormData} />,
//   //   <FamilyDetails onDataSave={setGetFamilyData}/>,
//     <PersonalDetails/>,
//     <FamilyDetails/>,
//     <ContactDetails />,
//   ];

//   const handleNext = () => {
//     setActiveStep((prev) => (prev < steps.length - 1 ? prev + 1 : prev));
//   };
// //  const handleNext = () => {
// //     if (activeStep === 0) {
// //     if (getFormData) {
// //       localStorage.setItem("personalDetails", JSON.stringify(getFormData));
// //       console.log("Saved Personal Details:", getFormData);
// //     } else {
// //       console.error("formData is not available yet.");
// //       return;
// //     }
// //   }

// //   if (activeStep === 1) {
// //     if (getFamilyData) {
// //       localStorage.setItem("familyDetails", JSON.stringify(getFamilyData));
// //       console.log("Saved Family Details:", getFamilyData);
// //     } else {
// //       console.error("getFamilyData is not available yet.");
// //       return;
// //     }
// //   }

// //   setActiveStep((prev) => (prev < steps.length - 1 ? prev + 1 : prev));
// // };

//   const handleBack = () => {
//     setActiveStep((prev) => (prev > 0 ? prev - 1 : prev));
//   };
//   return (
//     <div className="container">
//       <div className="addProfile-subcontainer ">
//         {/* stepper data */}

//         {/* Stepper Container */}
//         {/* <div>
//           <Link
//             to="/"
//             style={{
//               color: "#2B171B",
//               marginRight: "10px",
//               fontSize: "20px",
//               paddingTop: "20px",
//               textDecoration:"none"
//             }}
//           >
//             {" "}
//             <span>
//               <BsArrowLeft /> Back
//             </span>
//           </Link>
//         </div> */}
//           <div className="menu-items">
//                  <Link to="/home" style={{  color: '#716466',marginRight:'10px'}}> <span>
//                     <BsArrowLeft />
//                   </span></Link>
//                   <span>{translations[language].dashboard}</span>
//                   <span> {translations[language].profile}</span>
//                 </div>
//         <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
//           {steps.map((label, index) => (
//             <StepItem
//               key={index}
//               active={index === activeStep}
//               completed={index < activeStep}
//             >
//               {label}
//             </StepItem>
//           ))}
//         </Box>
//       </div>

//       {/* Step Content */}
//       <Paper elevation={0}>
//         {activeStep === steps.length ? (
//           <Typography variant="h5" color="green">
//             🎉 All Steps Completed! Your form has been submitted.
//           </Typography>
//         ) : (
//           <Typography
//             className="stepper-content"
//             sx={{ boxShadow: "none", textShadow: "none" }}
//           >
//             {stepContent[activeStep]}
//           </Typography>
//         )}
//       </Paper>

//       {/* Buttons */}
//       <Box sx={{ mt: 4 }}>
//         <Button
//           className="prev-button"
//           onClick={handleBack}
//           disabled={activeStep === 0}
//           variant="contained"
//           sx={{ mr: 2, backgroundColor: "#F24464" }}
//         >
//        {translations[language].btnPrevious}
//         </Button>

//         {activeStep === steps.length - 1 ? (
//           <Button
//             onClick={handleNext}
//             variant="contained"
//             sx={{ backgroundColor: "#F24464" }}
//           >
//            {translations[language].btnFinish}
//           </Button>
//         ) : (
//           <Button
//             onClick={handleNext}
//             variant="contained"
//             sx={{ backgroundColor: "#F24464" }}

//           >
//             {translations[language].btnNext}
//           </Button>
//         )}
//       </Box>
//     </div>
//   );
// }

import React from "react";
import { useState, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { Button, Box, Typography, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import { BsArrowLeft } from "react-icons/bs";

import { PersonalDetails } from "./personalDetails";
import { FamilyDetails } from "./familyDetails";
import { ContactDetails } from "./contactDetails";
import "./index.css";
import { toast, ToastContainer } from "react-toastify";

// Styled Step Component (Arrow Shape)
const StepItem = styled("div")(({ active, completed }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flex: 1,
  padding: "20px 24px",
  color: active || completed ? "#FFFFFF" : "#A8A8A8",
  backgroundColor: completed ? "#F24464" : active ? "#F24464" : "#E4E4E4",
  border: "1px solid #E4E4E4",
  position: "relative",
  clipPath: "polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%)",
  marginRight: active || completed ? "-8px" : "-8px",
  zIndex: active ? 2 : completed ? 1 : 0,
  transition: "0.3s",
  "&:last-child": {
    marginRight: 0,
  },
  fontSize: "16px",
  fontWeight: "500",
  marginTop: "20px",
}));
export function UploadUserAdd() {
  // const location =useLocation();
  // const { userId,  matchmakerName,planType } = location.state || {};
  const storedData =
    JSON.parse(sessionStorage.getItem("matchmakerProfileData")) || {};

  const { agentId, matchmakerName, planType, publicToken } = storedData;
  const navigate = useNavigate();

  const [activeStep, setActiveStep] = useState(0);
  const [getFormData, setGetFormData] = useState(null);
  const [getFamilyData, setGetFamilyData] = useState(null);
  const [getContactData, setGetContactData] = useState(null);

  const steps = ["Personal Details", "Family Details", "Contact Details"];

  const stepContent = [
    <PersonalDetails />,
    <FamilyDetails />,
    <ContactDetails userId={agentId} matchmakerName={matchmakerName} />,
  ];

  // const handleNext = () => {
  //   setActiveStep((prev) => (prev < steps.length - 1 ? prev + 1 : prev));
  //     const personalDetails = localStorage.getItem("personalDetails");
  //      const familyDetails = localStorage.getItem("familyDetails");

  // };
  const handleNext = () => {
    const personalDetails = localStorage.getItem("personalDetails");
    const familyDetails = localStorage.getItem("familyDetails");

    if (activeStep === 0 && (!personalDetails || personalDetails === "null")) {
      toast.warning("Please save the personal details before proceeding.");
      return;
    }

    if (activeStep === 1 && (!familyDetails || familyDetails === "null")) {
      toast.warning("Please save the family details before proceeding.");
      return;
    }
    // this for finish button
    if (activeStep === steps.length - 1) {
      // setActiveStep((prev) => prev + 1);
      toast.warning("Please click the Submit button to complete your profile");
      return;
    }

    setActiveStep((prev) => (prev < steps.length - 1 ? prev + 1 : prev));
  };

  const handleBack = () => {
    setActiveStep((prev) => (prev > 0 ? prev - 1 : prev));
  };
  return (
    <>
      <ToastContainer />
      <div className="container">
        <div className="addProfile-subcontainer ">
          {/* stepper data */}

          {/* Stepper Container */}
          {/* <div>
          <Link
            to="/"
            style={{
              color: "#2B171B",
              marginRight: "10px",
              fontSize: "20px",
              paddingTop: "20px",
              textDecoration:"none"
            }}
          >
            {" "}
            <span>
              <BsArrowLeft /> Back
            </span>
          </Link>
        </div> */}
          <div className="menu-items d-flex gap-2">
            <div
              onClick={() =>
                navigate("/matchmaker-profiles-uploaded", {
                  // state: {
                  //   userId: userId,
                  //   matchmakerName: matchmakerName,
                  //   planType:planType,
                  // },
                })
              }
              style={{ color: "#2B171B", marginRight: "10px" }}
            >
              {" "}
              <span>
                <BsArrowLeft />
              </span>
            </div>

            <span>Dashboard </span>
            <span> /Profiles</span>
          </div>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
            {steps.map((label, index) => (
              <StepItem
                key={index}
                active={index === activeStep}
                completed={index < activeStep}
              >
                {label}
              </StepItem>
            ))}
          </Box>
        </div>

        {/* Step Content */}
        <Paper elevation={0}>
          {activeStep === steps.length ? (
            <Typography variant="h5" color="green">
              🎉 All Steps Completed! Your form has been submitted.
            </Typography>
          ) : (
            <Typography
              className="stepper-content"
              sx={{ boxShadow: "none", textShadow: "none" }}
            >
              {stepContent[activeStep]}
            </Typography>
          )}
        </Paper>

        {/* Buttons */}
        {/* <Box sx={{ mt: 4 }}>
          <Button
            className="prev-button"
            onClick={handleBack}
            disabled={activeStep === 0}
            variant="contained"
            sx={{ mr: 2, backgroundColor: "#F24464" }}
          >
           Previous
          </Button>

          {activeStep === steps.length - 1 ? (
            <Button
              onClick={handleNext}
              variant="contained"
              sx={{ backgroundColor: "#F24464" }}
            >
              Finish
            </Button>
          ) : (
            <Button
              onClick={handleNext}
              variant="contained"
              sx={{ backgroundColor: "#F24464" }}
            >
              Next
            </Button>
          )}
        </Box> */}
        <Box sx={{ mt: 4 }}>
          <Button
            className="prev-button"
            onClick={handleBack}
            disabled={activeStep === 0}
            variant="contained"
            sx={{ mr: 2, backgroundColor: "#F24464" }}
          >
            Previous
          </Button>

          {activeStep === steps.length - 1 ? (
            <Button
              variant="contained"
              disabled
              sx={{ backgroundColor: "#ccc", color: "#000" }}
            >
              Next
            </Button>
          ) : (
            <Button
              onClick={handleNext}
              variant="contained"
              sx={{ backgroundColor: "#F24464" }}
            >
              Next
            </Button>
          )}
        </Box>
      </div>
    </>
  );
}
